(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-facets"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const carets = document.querySelectorAll('.facet-filters__field .icon-caret');
  setTimeout(function() {
    carets.forEach(function(caret) {
      caret.style.width = '10px';
      caret.style.height = '6px';
      caret.style.position = 'absolute';
      caret.style.right = '15px';
      caret.style.top = '50%';
      caret.style.transform = 'translateY(-50%)';
      caret.style.color = '#000000';
      caret.style.display = 'block';
      caret.style.zIndex = '2';
    });
    const selectEl = document.querySelector('.facet-filters__sort');
if (selectEl) {
  selectEl.style.width = 'calc(100% - 30px)';
}
  }, 500);
});
  } catch(e) { console.error(e); }
})();

})();
